/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StarShipmentRequest
 */
export interface StarShipmentRequest {
    /**
     * 
     * @type {string}
     * @memberof StarShipmentRequest
     */
    shipmentId: string;
    /**
     * 
     * @type {string}
     * @memberof StarShipmentRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the StarShipmentRequest interface.
 */
export function instanceOfStarShipmentRequest(value: object): value is StarShipmentRequest {
    if (!('shipmentId' in value) || value['shipmentId'] === undefined) return false;
    return true;
}

export function StarShipmentRequestFromJSON(json: any): StarShipmentRequest {
    return StarShipmentRequestFromJSONTyped(json, false);
}

export function StarShipmentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StarShipmentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'shipmentId': json['shipmentId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

  export function StarShipmentRequestToJSON(json: any): StarShipmentRequest {
      return StarShipmentRequestToJSONTyped(json, false);
  }

  export function StarShipmentRequestToJSONTyped(value?: StarShipmentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'shipmentId': value['shipmentId'],
        'reason': value['reason'],
    };
}

